import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseOperationPaymentRequestTemplates = [
  {
    id: '-117001',
    language: Language.EN,
    subject: 'Invitation to pay a service or an exceptional charge',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>We invite you to pay the service charge labelled "<i>{{lvoLabel lvo language}}</i>" for the lease located at <strong>{{getLeaseMainAddress lease}}</strong>. Please find all details below:</p>
        <ul><li>Account number held by {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Amount: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Remittance information: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if displayOpenBalance}}
        <p>Your current account balance is <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if (shouldShowPaymentProviderPaymentLink lease invoice)}}
        <p>You can pay online here: {{paymentProviderPaymentLinkTag paymentProviderPaymentLink language}}</p>
        <p></p>
        {{/if}}
        <p>Please find a detailed {{getInvoiceOrPaymentRequest lease}} attached.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* This amount may not be up to date, if your payment has crossed the issue of this one.</p>
        {{/if}}
        `,
  },
  {
    id: '-117002',
    language: Language.FR,
    subject: 'Invitation à payer un frais de service ou une charge exceptionnelle',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Nous vous invitons à payer le frais de service libellé "<i>{{lvoLabel lvo language}}</i>" pour le bail sis <strong>{{getLeaseMainAddress lease}}</strong>. Veuillez trouver les details ci dessous:</p>
        <ul><li>Numéro de compte au nom de {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Montant: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Communication: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if displayOpenBalance}}
        <p>Votre solde actuel est de <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if (shouldShowPaymentProviderPaymentLink lease invoice)}}
        <p>Vous pouvez payer en ligne ici : {{paymentProviderPaymentLinkTag paymentProviderPaymentLink language}}</p>
        <p></p>
        {{/if}}
        <p>Veuillez trouver une {{getInvoiceOrPaymentRequest lease}} détaillée en pièce jointe.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Ce montant pourrait ne pas être à jour, si votre paiement à croisé l'émission de la présente.</p>
        {{/if}}`,
  },
  {
    id: '-117003',
    language: Language.NL,
    subject: 'Uitnodiging om een dienstvergoeding of een uitzonderlijke heffing te betalen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Wij nodigen u uit om de dienstvergoeding met label "<i>{{lvoLabel lvo language}}</i>" gelegen op <strong>{{getLeaseMainAddress lease}}</strong> te betalen. Hieronder vindt u alle details:</p>
        <ul><li>Rekeningnummer bij {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Bedrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Mededeling: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if displayOpenBalance}}
        <p>Uw huidige rekeningsaldo is: <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if (shouldShowPaymentProviderPaymentLink lease invoice)}}
        <p>U kunt hier online betalen: {{paymentProviderPaymentLinkTag paymentProviderPaymentLink language}}</p>
        <p></p>
        {{/if}}
        <p>Gelieve een gedetailleerde {{getInvoiceOrPaymentRequest lease}} bijgevoegd te vinden.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Het kan zijn dat dit bedrag niet up-to-date is, als uw betaling de uitgifte van deze heeft overschreden.</p>
        {{/if}}
        `,
  },
  {
    id: '-117004',
    language: Language.DE,
    subject: 'Einladung zur Zahlung einer Servicegebühr oder einer außergewöhnlichen Abgabe',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_PAYMENT_REQUEST,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Wir laden Sie ein, die Servicegebühr mit der Bezeichnung "<i>{{lvoLabel lvo language}}</i>" für den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong> zu bezahlen. Bitte finden Sie alle Details unten:</p>
        <ul><li>Kontonummer bei {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Betrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Verwendungszweck: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        {{#if displayOpenBalance}}
        <p>Ihr aktueller Kontostand beträgt <strong>{{accountBalance}} €</strong>*.</p>
        <p></p>
        {{/if}}
        {{#if (shouldShowPaymentProviderPaymentLink lease invoice)}}
        <p>Sie können hier online bezahlen: {{paymentProviderPaymentLinkTag paymentProviderPaymentLink language}}</p>
        <p></p>
        {{/if}}
        <p>Bitte finden Sie eine detaillierte {{getInvoiceOrPaymentRequest lease}} im Anhang.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        <p></p>
        <p></p>
        {{#if displayOpenBalance}}
        <p>* Dieser Betrag ist möglicherweise nicht aktuell, falls sich Ihre Zahlung mit der Ausstellung überschnitten hat.</p>
        {{/if}}
        `,
  },
];
